Vue.component('givePack', {
  template: templates.givePack,
  data() {
    return {
      model: {
        packId: null,
        packs: {},
        searchResults: [],
        saving: false,
        isOn: false,
        streamerPacks: {},
        hasResult: null,
        subscriptions: {},
        isLoading: false,
        isAdmin: false
      }
    }
  },
  mounted() {
    const c = this;
    c.get();
    c.connect();

    c.$root.$on('CancelledPack', data => {
      c.get();
    })

    if(utils.cookies.get('user_role') === 'admin'){
      c.model.hasResult = true;
      c.model.isLoading = true;
    }

    
  },
  methods: {
    connect() {
      const c = this;
      c.ws = new WebSocket(utils.getWsUrl());

      c.ws.onmessage = (event) => {
        const messageData = event.data;

        try {
          const parsedData = JSON.parse(messageData);

          // Skip auth confirmation messages
          if (parsedData.message === 'authenticated') {
            console.log('[givePack] Authenticated, connectionId:', parsedData.connectionId);
            return;
          }

          if(parsedData.channelId === utils.cookies.get('channelId') && parsedData.message === 'pack_given'){
            c.get();
          }
        } catch (error) {
          console.error('Error parsing message data:', error);
        }
      };

      c.ws.onopen = () => {
        console.log('[givePack] WebSocket connection established');

        // Send authentication message after connection opens
        const accessToken = utils.cookies.get('access_token');
        const userId = utils.cookies.get('user_id');
        if (accessToken && userId) {
          c.ws.send(JSON.stringify({
            message: 'auth',
            token: accessToken,
            userId: userId
          }));
          console.log('[givePack] Sent auth message');
        }
      };

      c.ws.onerror = (error) => {
        console.error('[givePack] WebSocket error:', error);
      };

      c.ws.onclose = (event) => {
        console.log('[givePack] WebSocket connection closed. Code:', event.code, 'Reason:', event.reason);
      };
    },
    get() {
      const c = this;
      let data = {};

      packService.getStreamer()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }
          c.model.packs = data;
          c.streamerPacks();
        })
        .catch(function (error) {
          //console.log(error);
        });
        console.log(c.model)
    },
    searchUsers() {
      const c = this;
      let names = [];
      const twitchDisplayName = $('[name="unlock-user"]').val();
  
      userService.search({twitchDisplayName: twitchDisplayName})
          .then(function (response) {
              c.model.searchResults = response.data;
  
              // Create a mapping of display names to connection IDs
              const userMap = {};
              for (let data of response.data) {
                  names.push(data.twitchDisplayName);
                  userMap[data.twitchDisplayName] = data.connectionId; // Map display name to connection ID
              }
  
              // Initialize autocomplete
              $('[name="unlock-user"]').autocomplete({
                  source: names,
                  select: function(event, ui) {
                      const selectedDisplayName = ui.item.value;
                      const connectionId = userMap[selectedDisplayName]; // Get the connection ID
                      console.log("Selected Connection ID:", connectionId); // Use the connection ID as needed
                      c.model.connectionId = connectionId;
                  }
              });
          })
          .catch(function (error) {
              console.error("Error fetching users:", error);
          });
  },
  
    toggle() {
      const c = this;
      c.model.isOn = !c.model.isOn;
    },
    getUserId(twitchDisplayName, callback) {
      const c = this;
      for (let user of c.model.searchResults) {
        if (user.twitchDisplayName == twitchDisplayName) {
          callback(user.twitchId);
          return;
        }
      }

      twitchAPI.getUserByLogin(twitchDisplayName, function(userData) {
          for (let data of userData) {
            callback(data.id);
            return;
          }
          
          utils.alert.error(`User doesn't exist!`);
      });
    },
    save() {
      const c = this;
      const twitchDisplayName = $('[name="unlock-user"]').val();
      
      if (c.model.saving) {
        return;
      }

      c.getUserId(twitchDisplayName, function(twitchId) {

        if (!twitchId || !c.model.packId) {
          utils.alert.error('User and pack required!');
          return;
        }
        const data = {
          twitchId: twitchId,
          packId: c.model.packId,
          toHq: c.model.isOn,
          subscriptions: c.model.subscriptions,
          isChest : c.model.packs[`${c.model.packId}`].isChest,
          message: 'pack_given',
          status: 'pack_given',
          channelId: utils.cookies.get('channelId'),
        }

        unlockQueueService.save(data)
          .then(function (response) {
            if(response.data.status === 400){
              utils.alert.error(response.data.message);
              return;
            }
            utils.alert.success(`Pack given to ${twitchDisplayName}`);
            c.streamerPacks()
            c.$root.$emit('packGiven');

            if(c.model.isOn || c.model.packs[`${c.model.packId}`].isChest){
              data.status = 'give_pack';
            }

            // Use fresh connectionId from API response for targeted WebSocket messaging
            const targetConnectionId = response.data.connectionId;
            const wsMessage = {
              twitchId: data.twitchId,
              packId: data.packId,
              message: data.message,
              status: data.status,
              channelId: data.channelId,
              isChest: data.isChest
            };

            // Only add targetConnectionId if recipient is currently connected
            if (targetConnectionId) {
              wsMessage.targetConnectionId = targetConnectionId;
              console.log('[givePack] Sending targeted WebSocket message to connection:', targetConnectionId, wsMessage);
            } else {
              console.log('[givePack] Recipient not connected, broadcasting message:', wsMessage);
            }
            c.ws.send(JSON.stringify(wsMessage));
           
            c.reset();
          })
          .catch(function (error) {
            utils.alert.error('Somthing went wrong giving this pack!');
          });

      });
    },
    reset() {
      const c = this;
      $('[name="unlock-user"]').val('');
      c.model.packId = null;
      c.model.saving = false;
    },
    streamerPacks() {
      const c = this;
      packService.getStreamerPacks()
          .then(response => {


            console.log(response)
              c.model.isLoading = true;

              if(response.data.subscriptions.subscriptions.length >0){
                c.model.hasResult = true;
         
              }
              else{
                c.model.hasResult = false;
              }
           
              const packData = response.data.totals; 
              c.model.subscriptions = response.data.subscriptions.subscriptions; 

              console.log(c.model)
              
              // Find pack IDs for each type
              const packTypes = {
                'Standard': [],
                'Ultra': [],
                'Legendary': [],
                'Prime Chest': [],
                'Ultra Chest': [],
                'Legendary Chest': []
              };

              // Group packs by type
              for (let packId in c.model.packs) {
                const pack = c.model.packs[packId];
                const packName = pack.name.toLowerCase();

                console.log(packName)

                // Categorize packs
                if (packName.includes('standard') && packName.includes('pack')) {
                  packTypes['Standard'].push(packId);
                } else if (packName.includes('ultra') && packName.includes('pack')) {
                  packTypes['Ultra'].push(packId);
                } else if (packName.includes('legendary') && packName.includes('pack')) {
                  packTypes['Legendary'].push(packId);
                }

                // Categorize chests by type
                if (packName.includes('prime') && packName.includes('chest')) {
                  packTypes['Prime Chest'].push(packId);
                } else if (packName.includes('ultra') && packName.includes('chest')) {
                  packTypes['Ultra Chest'].push(packId);
                } else if (packName.includes('legendary') && packName.includes('chest')) {
                  packTypes['Legendary Chest'].push(packId);
                }
              }

              // Create streamer packs array with pack IDs
              c.model.streamerPacks = [
                { type: 'Standard', count: packData.standard, packIds: packTypes['Standard'] },
                { type: 'Ultra', count: packData.ultra, packIds: packTypes['Ultra'] },
                { type: 'Legendary', count: packData.legendary, packIds: packTypes['Legendary'] },
                { type: 'Prime Chest', count: packData.primeChest, packIds: packTypes['Prime Chest'] },
                { type: 'Ultra Chest', count: packData.ultraChest, packIds: packTypes['Ultra Chest'] },
                { type: 'Legendary Chest', count: packData.legendaryChest, packIds: packTypes['Legendary Chest'] }
              ];

              console.log(c.model.streamerPacks)
          })
          .catch(error => {
              // console.error(error);
          });
    },
    getPackImageUrl(pack) {
      const c = this;

      
      // Get the first pack ID for this type
      if (pack.packIds && pack.packIds.length > 0) {
        const packId = pack.packIds[0];
        const packData = c.model.packs[packId];
        
        if (packData) {
          // Check if pack has uploaded images
          if (packData.images && Object.keys(packData.images).length > 0) {
            console.log(packData)
            const firstImageKey = Object.keys(packData.images)[0];
            const imageName = packData.images[firstImageKey];
            const folder = packData.chest_active || packData.isChest ? 'chest' : 'packs';
            const imageUrl = packData.chest_active || packData.isChest
              ? `${root}/images/${folder}/${packId}/1.png`
              : `${root}/images/${folder}/${packId}.png`;
            return imageUrl;
          }
          
          // Fallback to default image path
          const folder = packData.chest_active || packData.isChest ? 'chest' : 'packs';
          const defaultPath = packData.chest_active || packData.isChest
            ? `${root}/images/${folder}/${packId}/${packId}/1.png`
            : `${root}/images/${folder}/${packId}/${packId}.png`;
          return defaultPath;
        }
      }
      
      return null;
    }
  
  }
});